import React, { useState, useEffect } from 'react';
import styles from './Header.module.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const currentDomain = window.location.hostname;
  const isRegionSite = currentDomain !== 'regioncheck.ru' && currentDomain.endsWith('.regioncheck.ru');

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <div className="container">
        <div className={styles.headerContent}>
          <div className={styles.logo}>
            <a href="/">
              <i className="fa fa-qrcode"></i>
              <span>REGIONCHECK</span>
            </a>
          </div>

          <button 
            className={styles.mobileToggle}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
            <a href="#regions">Города</a>
            <a href="#features">Преимущества</a>
            <a href="#contact">Контакты</a>
            {isRegionSite && (
              <a href={`https://regioncheck.ru?from=${currentDomain.split('.')[0]}`} className={styles.backToMain}>
                ← На главный сайт
              </a>
            )}
          </nav>

          <div className={styles.phone}>
            <a href="tel:+79874817932">
              <i className="fa fa-phone"></i> +7 (987) 481-79-32
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;